import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styles from './IndexPage.module.css';

const IndexPage: React.FC = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);
  
  useEffect(() => {
    // Check if user is logged in by looking for tokens
    const token = localStorage.getItem("token");
    const refreshToken = localStorage.getItem("refreshToken");
    
    if (token && refreshToken) {
      // User is logged in, redirect to home
      setIsLoggedIn(true);
      navigate('/home');
    } else {
      // User is not logged in, show welcome page
      setIsLoggedIn(false);
    }
  }, [navigate]);

  // Show loading state while checking authentication
  if (isLoggedIn === null) {
    return <div>Loading...</div>;
  }
  
  // If not redirecting, show welcome page
  return (
    <div className={styles.container}>
      {/* Navigation */}
      <nav className={styles.navigation}>
        <div className={styles.navContainer}>
          <div className={styles.navContent}>
            <div className={styles.logoContainer}>
              <Link to="/" className={styles.logoLink}>
                <img src="/img/buildyou_logo@3x.png" alt="BuildYou Logo" className={styles.logoImage} />
              </Link>
            </div>
            {/* Desktop menu */}
            <div className={styles.desktopMenu}>
              <div className={styles.menuItems}>
                <Link to="/login" className={styles.loginButton}>Login</Link>
              </div>
            </div>
            {/* Mobile menu */}
            <div className={styles.mobileMenu}>
              <Link to="/login" className={styles.loginButtonMobile}>Login</Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroContainer}>
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>BuildYou</h1>
            <p className={styles.heroSubtitle}>Currently in alpha</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className={styles.footer}>
        <div className={styles.footerContainer}>
          <div className={styles.footerContent}>
            <p>&copy; 2025 BuildYou, LLC. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default IndexPage; 